<p-toast></p-toast>
<app-loading-overlay></app-loading-overlay>
<div class="app-shell">
    <app-side-menu></app-side-menu>
    <div class="main-area" [class.collapsed]="sidebarCollapsed()">
        <app-header></app-header>
        <main class="content-area">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
